import { render, staticRenderFns } from "./PressNumber.vue?vue&type=template&id=4aea115e&scoped=true&"
import script from "./PressNumber.vue?vue&type=script&lang=js&"
export * from "./PressNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea115e",
  null
  
)

export default component.exports